//DSS Documentation on Angular Components - http://tiny.sc/cgangularcomponent
import { Component, EventEmitter, OnInit, AfterViewInit, Output, } from '@angular/core';
import { NgModule } from '@angular/core';
import { ViewChild } from '@angular/core';
import { } from 'googlemaps';
import { func } from 'prop-types';
import { HttpService } from './http.service';
import { SocoHttpService } from '@soco/http';
import { DBTraceLogService } from '../shared/services/dbTraceLog/dbTraceLog.service';
import { CoolEmailService } from '../shared/services/coolEmail/coolEmail.service';
import { AppCommonService } from '../shared/services/common/app-common.service';
import { Router, ActivatedRoute, NavigationEnd, ParamMap } from '@angular/router';
import { ApiResult } from '@soco/core';
import { promise } from 'selenium-webdriver';
import { DatePipe } from '@angular/common';
import { DeviceDetectorService } from 'ngx-device-detector';
import { DBTraceLog, LogType } from '../shared/services/dbTraceLog/dbTraceLog-entities';
import { AppConfigurationData } from '../shared/services/common/app-common-entities';
import { AppBaseComponent } from '../shared/components/base/app-base.component';

@Component({
    templateUrl: 'components.component.html',
    styleUrls: ['components.component.css'],
    providers: [HttpService, DatePipe, DBTraceLogService, CoolEmailService, AppCommonService]
})
export class ComponentsComponent extends AppBaseComponent implements OnInit {

    public param1: string = '';
    public ETA: any;
    public ApiResp: any;
    public MyResult: any;
    public MapLatitude: any;
    public MapLongitude: any;
    public Customerlatitude: any;
    public Customerlongitude: any;
    public Technicianlatitude: any;
    public Technicianlongitude: any;
    public mapType = 'mapType';
    public response: any;
    @ViewChild("gmap", { static: true }) gmapElement: any;
    map: google.maps.Map;
    entraceInstuctions = [];
    public data: any;
    public InReview: boolean;
    public Enroute: boolean;
    public Onsite: boolean;
    public Complete: boolean;
    public enrouteFlag: boolean;
    public reminderFlag: boolean;
    public completeFlag: boolean;
    public CGIFlag: boolean;
    public incompleteFlag: boolean;
    public completeText: string;
    public image: string;
    public waterMarkImage: string;
    public unit: boolean;
    public ldc: string = '';
    public ErrorMessage: boolean;
    public showIcon: boolean;
    public AppointmentTitle: string;
    public statusMessage: boolean;
    public case0: boolean;
    public case1: boolean;
    public case2: boolean;
    public case3: boolean;
    public case4: boolean;
    public case5: boolean;
    public Aglc: boolean;
    public Nicor: boolean;
    public Virgina: boolean;
    public Chattanooga: boolean;
    public OrderVoid: boolean;
    public TechDistance: any;
    public ZoomLevel: any;
    public GeoLoc: boolean;
    public SuspendFlag: boolean;
    public statusEnroute: boolean;
    public statusOnsite: boolean;
    public arrival: boolean;
    public onsiteTime: any;
    public reschedule: boolean;
    public RescheduleUrl: string;
    public faqUrl: any;
    public callBack: any;
    public covidvideo: any;
    public orderType: string = '';
    public orderNumber: string = '';
    public deviceInfo = null;
    public dbTraceLog: DBTraceLog;
    public logReferenceID: string = '';
    public NoData: boolean;
    public apiResponse400:boolean=false;
    mySubscription: any;
    public appConfigurationDataList: Array<AppConfigurationData> = [];
    public emailToList: string;
    public energyEfficiencyLink:string = '';
    public NoDiggity:string = '';
    showInitialSpinner = false;
    public energyAssistanceLink: string = '';


    @Output() messageEvent = new EventEmitter<string>();


    constructor(public httpService: HttpService, private route: ActivatedRoute, private router: Router, public datepipe: DatePipe,
        public socoHttp: SocoHttpService, public dbTraceLogService: DBTraceLogService, public deviceService: DeviceDetectorService,
        public coolEmailService: CoolEmailService, private appCommonService: AppCommonService) {

        //Parent component initialization
        super(socoHttp, dbTraceLogService, coolEmailService, deviceService);

        this.router.routeReuseStrategy.shouldReuseRoute = function () {
            return false;
        };
        this.mySubscription = this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                // Trick the Router into believing it's last link wasn't previously loaded
                this.router.navigated = false;
            }
        });

        this.param1 = this.route.snapshot.url[0].path;

        this.logReferenceID = this.datepipe.transform(Date.now(), "MMddyyyyHHmmss");
        this.insertDBTraceLog(LogType.Info, 'Customer portal component initiated successfully');

        //To capture public ip
        //this.httpT.get('https://jsonip.com/').subscribe(data => {

        //    var ip = JSON.stringify(data);
        //    this.insertDBTraceLog(LogType.Info, `Customer portal component initiated successfully - ${window.location.href} , ${ip}`);            
        //});

        // this.NoData = true;
        //this.FetchData(true);
        this.FetchInitialDataWithAppConfigs();
        let counter = 0;
        this.callBack = setInterval(() => {
            this.FetchData(false);
        }, 25000);
      
    };


    ngOnInit() {

        ////Get device Info
        //this.deviceInfo = this.deviceService.getDeviceInfo();

        //if (this.deviceInfo != null && this.deviceService != null)
        //    this.insertDBTraceLog(LogType.Info, 'Device Info captured successfully');
        //else
        //    this.insertDBTraceLog(LogType.Error, 'Error occured while capturing Device Info');
    }

    FetchData(isInitialLoad: boolean) {

        //this.showInitialSpinner = true;
        try {
            if(!this.apiResponse400)
            {
                this.httpService.getData(this.param1).subscribe(ApiResult => {
                    
                    if (ApiResult != null && ApiResult.statusCode == 200) {
                        this.NoData = false;
                        this.GetOrderDetails(ApiResult, isInitialLoad);
                    }
                    else if (isInitialLoad) {
                        this.insertDBTraceLog(LogType.Error, 'Error occured while fetching order details, APIResult is null or APIResult is not 200');
                        this.showInitialSpinner = false;
                    }
                    if(ApiResult != null && ApiResult.statusCode!=200){
                        this.apiResponse400=true;
                    }
                },
                ApiResult => {                 

                    if(ApiResult != null && ApiResult.statusCode!=200){
                        this.apiResponse400=true;
                    }
                    if (isInitialLoad && (this.socoHttp.isInvalidResult(ApiResult) || this.socoHttp.isErrorResult(ApiResult) || this.socoHttp.isFailureResult(ApiResult))) {
                        this.NoData = true;
                        this.insertDBTraceLog(LogType.Error, 'Error occured while fetching order details, APIResult is invalid');
                        this.showInitialSpinner = false;
                    }
            });
        }

            this.RescheduleUrl = 'https://' + window.location.hostname + '/reschedule/' + this.param1;
            this.faqUrl = 'https://' + window.location.hostname + '/faq/' + this.param1;
        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while fetching order details, Error: ' + e.message.substring(0, 500));
        }
       
    }

    FetchInitialDataWithAppConfigs() {
        this.showInitialSpinner = true;
        try {

            this.appCommonService.getApplicationConfigs().subscribe(ApiResult => {
                if (ApiResult.data != null) {

                    this.insertDBTraceLog(LogType.Info, 'Application configs fetched successfully');

                    ApiResult.data.forEach(configData => {
                        this.appConfigurationDataList.push(configData);
                    });

                    this.emailToList = this.appConfigurationDataList.filter(item => (item.configurationKey == 'EmailTo'))
                        .map(cv => cv.configurationValue)[0];

                    //Load Initial data
                    this.FetchData(true);                   
                }
                else {
                    this.insertDBTraceLog(LogType.Error, 'Error occured while fetching application configs, API Result is Null');
                    this.showInitialSpinner = false;
                }

            }, ApiResult => {
                //capture error
                if (this.socoHttp.isInvalidResult(ApiResult) || this.socoHttp.isErrorResult(ApiResult) || this.socoHttp.isFailureResult(ApiResult)) {
                    this.insertDBTraceLog(LogType.Error, 'Error occured while fetching application configs');
                }
            });

        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while fetching application configs, Error: ' + e.message.substring(0, 500));
        }

    }    

    GetOrderDetails(ApiResult: any, isInitialLoad: boolean) {
        this.response = ApiResult;
        if (this.response.statusCode !== 200 || this.response.data.isUrlExpired) {

            this.ErrorMessage = true;
        } else if (this.response.statusCode == 404 ) {
            this.NoData = true;
        }
        if (this.response && this.response.data) {
            let data = this.response.data;
            this.energyEfficiencyLink = data.energyEfficiencyLink;
            this.NoDiggity = data.noDiggity;
            if ((data.appointmentStart == '' || data.appointmentStart == null || data.appointmentStart == undefined) &&
                (data.address == '' || data.address == null || data.address == undefined) &&
                (data.activityType == '' || data.activityType == null || data.activityType == undefined) &&
                (data.activityGroup == '' || data.activityGroup == null || data.activityGroup == undefined) &&
                (data.orderStatus == '' || data.orderStatus == null || data.orderStatus == undefined) &&
                (data.orderStatusCd == '' || data.orderStatusCd == null || data.orderStatusCd == undefined) &&
                (data.serviceArea == '' || data.serviceArea == null || data.serviceArea == undefined)) {
                this.NoData = true;
            } else {
                this.NoData = false;
            }
        }

        this.ldc = this.response.data.ldc;
        this.AppointmentTitle = 'Appointment Details';
        if (this.response.data.orderStatus === '4') {
            if (this.response.data.statusMessage == 'undefined' || this.response.data.statusMessage == 'null' || this.response.data.statusMessage == '') {
                this.response.data.statusMessage = 'We arrived at your property. However, we were unable to complete work for your appointment. Call Georgia Natural Gas at 1.877.850.6200 to reschedule your appointment.';
            }
        }
        if (this.ldc === 'AGLC') {
            this.Aglc = true;
            this.waterMarkImage = '../../assets/images/AGL_rev.png';
            this.energyAssistanceLink = 'https://www.atlantagaslight.com/energyassistance';
            //this.covidvideo = 'https://vimeo.com/443234585/0bd98e0a44';
        }
        else if (this.ldc === 'NG') {
            this.Nicor = true;
            this.waterMarkImage = '../../assets/images/NG_rev.png';
            this.energyAssistanceLink = 'https://www.nicorgas.com/energyassistanceinfo';
            //this.covidvideo = 'https://vimeo.com/443235074/197b149ce7';
        }
        else if (this.ldc === 'VNG') {
            this.Virgina = true;
            this.waterMarkImage = '../../assets/images/VNG_rev.png';
            this.energyAssistanceLink = 'https://www.virginianaturalgas.com/energyassistance';
            //this.covidvideo = 'https://vimeo.com/443235285/384974ef32';
        }
        else if (this.ldc === 'CGC') {
            this.Chattanooga = true;
            this.waterMarkImage = '../../assets/images/CGC_rev.png';
            this.energyAssistanceLink = 'https://www.chattanoogagas.com/energyassistance';
            //this.covidvideo = 'https://vimeo.com/443234820/f10ec21ea9';
        }

        if (this.response.data.unit) {
            this.unit = true
        } else this.unit = false;


        //Fetch Reschedule Eligibility from KMIOrderLogs (Biztalk) to determine button visibility
        this.determineRescheduleEligibility(this.param1);

        if (this.response.data.orderStatusCd == 'Enroute') {
            this.statusEnroute = true;
        } else this.statusEnroute = false;

        if (this.response.data.orderStatusCd == "OnSite"
            || this.response.data.orderStatusCd == "DocumentationOnly"
            || this.response.data.orderStatusCd == "PartialComplete"
            || this.response.data.orderStatusCd == "Reporting") {
            this.statusOnsite = true;
        } else this.statusOnsite = false;

        this.onsiteTime = this.response.data.onsiteTime;

        if (this.onsiteTime == '' || this.onsiteTime == 'NULL' || this.onsiteTime == undefined) {
            this.arrival = false;
        } else this.arrival = true;

        this.TechDistance = parseFloat(this.response.data.technicianDistance);

        if (this.TechDistance) {
            if (this.TechDistance > 0 && this.TechDistance <= 0.5) {
                this.ZoomLevel = 14.5;
            } else if (this.TechDistance > 0.5 && this.TechDistance <= 1) {
                this.ZoomLevel = 13.2;
            } else if (this.TechDistance > 1 && this.TechDistance <= 2) {
                this.ZoomLevel = 12.7;
            } else if (this.TechDistance > 2 && this.TechDistance <= 5) {
                this.ZoomLevel = 11.2;
            }
            else if (this.TechDistance > 5 && this.TechDistance <= 10) {
                this.ZoomLevel = 10;
            } else if (this.TechDistance > 10 && this.TechDistance <= 20) {
                this.ZoomLevel = 9;
            }
            else if (this.TechDistance > 20 && this.TechDistance <= 50) {
                this.ZoomLevel = 8;
            } else if (this.TechDistance > 50 && this.TechDistance <= 100) {
                this.ZoomLevel = 7;
            } else if (this.TechDistance > 100 && this.TechDistance <= 200) {
                this.ZoomLevel = 6.5;
            } else if (this.TechDistance > 200) {
                this.ZoomLevel = 5;
            }
        } else this.ZoomLevel = 7;

        if (this.response.data.orderStatus === '0') {
            this.InReview = true;
        } else { this.InReview = false; }

        if (this.InReview && !this.ErrorMessage) {
            this.case0 = true;
        } else this.case0 = false;

        if (this.response.data.orderStatus === '1') {
            this.Onsite = true;
            this.AppointmentTitle = 'Appointment Reminder';
        } else { this.Onsite = false; }

        if (this.Onsite && !this.ErrorMessage) {
            this.case1 = true;
        } else this.case1 = false;

        if (this.response.data.orderStatus === '2') {
            this.Enroute = true;
        } else { this.Enroute = false; }

        if (this.Enroute && !this.ErrorMessage) {
            this.case2 = true;
        } else this.case2 = false;

        if (this.response.data.orderStatus === '3') {
            this.Complete = true;
            this.completeFlag = true;
        } else { this.Complete = false; }

        if (this.Complete && !this.ErrorMessage) {
            this.case3 = true;
        } else this.case3 = false;

        if (this.response.data.orderStatusCd === 'Suspended') {
            this.SuspendFlag = true;

        } else { this.SuspendFlag = false; }

        if (this.response.data.orderStatusCd === 'CGI') {
            this.CGIFlag = true;

        } else { this.CGIFlag = false; }

        if (this.response.data.orderStatusCd === 'Voided') {
            this.OrderVoid = true;
        } else this.OrderVoid = false;

        if ((this.CGIFlag) && !this.ErrorMessage) {
            this.case4 = true;
        } else this.case4 = false;


        if (this.Enroute || this.Onsite || this.Complete || this.CGIFlag) {
            this.reminderFlag = true;
        }
        if (this.Enroute || this.Complete || this.CGIFlag) {
            this.enrouteFlag = true;
        }

        if (!this.CGIFlag && !this.Complete) {
            this.incompleteFlag = true;
            this.completeText = 'Incomplete';
        } else { this.completeText = 'Complete' }

        if (this.response.data.orderStatusCd === 'CGI' || this.response.data.orderStatusCd === 'Suspended') {
            this.statusMessage = true;
        } else this.statusMessage = false;

        if (this.response.data.technicianImage) {

            this.image = 'data:image/png;base64,' + this.response.data.technicianImage;
            this.showIcon = false;

        } else {
            this.showIcon = true;
            // this.image = '../../assets/images/Fleet-photo.jpg';
        }

        var displayETAMsg = false;
        var customerGeo = false;

        if ((this.response.data.latitude && this.response.data.longitude) &&
            (this.response.data.latitude != '' && this.response.data.longitude != '')) {

            this.Customerlatitude = parseFloat(this.response.data.latitude);
            this.Customerlongitude = parseFloat(this.response.data.longitude);

            if (this.Customerlatitude > 0 ) {
                customerGeo = true;
            }
        }

        if ((this.response.data.technicianLatitude && this.response.data.technicianLongitude )&&
        (this.response.data.technicianLatitude != '' && this.response.data.technicianLongitude != '')&&
            customerGeo) {

            this.Technicianlatitude = parseFloat(this.response.data.technicianLatitude);
            this.Technicianlongitude = parseFloat(this.response.data.technicianLongitude);

            if (this.Technicianlatitude > 0) {
                displayETAMsg = true;
            }

        } 

        this.ETA = this.response.data.eta;
        if (!displayETAMsg || !customerGeo || this.ETA == null || this.ETA == '') {
            this.ETA = 'The estimated time of arrival is currently not available.';
        }


        let dist = this.response.data.technicianDistance;

        if (dist == '-1' || dist == null || dist == '' || dist == 'NULL') {
            this.GeoLoc = false;
        } else this.GeoLoc = true;

        this.MapLatitude = parseFloat(this.response.data.latitude); //33.7490; // 
        this.MapLongitude = parseFloat(this.response.data.longitude); // -84.3880; // 
        this.Customerlatitude = parseFloat(this.response.data.latitude); //33.7490; // 
        this.Customerlongitude = parseFloat(this.response.data.longitude); // -84.3880;//

        var str = this.response.data.entranceInstructions;
        this.entraceInstuctions = str.split('|');

       
        if (this.response.data.orderStatus === '3' || this.response.data.orderStatus === '4') {
            clearInterval(this.callBack);
        }

        if (this.response.data.activityType != null)
            this.orderType = this.response.data.activityType;

        if (this.response.data.descriptionAttribute != null)
            this.orderType = this.orderType + '#' + this.response.data.descriptionAttribute;

        this.orderNumber = this.response.data.externalOrderNum != null ? this.response.data.externalOrderNum : '';

        //Perform logging for initial load, avoid logging in subsequent auto loads.
        if (isInitialLoad)
            this.insertDBTraceLog(LogType.Info, 'Order details fetched successfully');

        this.showInitialSpinner = false;
    }

    markerHomeIconUrl() {
        return require('../../assets/images/home.png');
    }

    markerTruckIconUrl() {
        return require('../../assets/images/truck.png');
    }


    ngOnDestroy() {
        if (this.mySubscription) {
            this.mySubscription.unsubscribe();
        }
    }

    determineRescheduleEligibility(urlCode: string) {
        this.httpService.getOrderAttributes(urlCode).subscribe(ApiResult => {

            if (ApiResult != null && ApiResult.data != null && ApiResult.data.isRescheduleEligible) {
                if (
                    this.response.data.orderStatusCd.toUpperCase() === 'COMPLETE' ||
                    this.response.data.orderStatusCd.toUpperCase() === 'CGI' ||
                    this.response.data.orderStatusCd.toUpperCase() === 'BUNDLED' ||
                    this.response.data.orderStatusCd.toUpperCase() === 'VOIDED' ||
                    this.response.data.orderStatusCd.toUpperCase() === 'REPORTING' ||
                    this.response.data.orderStatusCd.toUpperCase() === 'READY2SCHEDULE' ||
                    this.response.data.orderStatusCd.toUpperCase() === 'PARTIALCOMPLETE' ||
                    this.response.data.orderStatusCd.toUpperCase() === 'ONSITE' ||
                    this.response.data.orderStatusCd.toUpperCase() === 'NEEDSAPPROVAL' ||
                    this.response.data.orderStatusCd.toUpperCase() === 'INJEOPARDY' ||
                    this.response.data.orderStatusCd.toUpperCase() === 'HOLDSONP' ||
                    this.response.data.orderStatusCd.toUpperCase() === 'FIELDCOMPLETE' ||
                    this.response.data.orderStatusCd.toUpperCase() === 'ENROUTE' ||
                    this.response.data.orderStatusCd.toUpperCase() === 'DOCUMENTATIONONLY'
                ) {
                    this.reschedule = false;
                }
                else {
                    this.reschedule = true;
                }
            }
            else {
                this.reschedule = false;
            }
        });
    }

    private insertDBTraceLog(logType: string, logMessage: string) {

        this.dbTraceLog = new DBTraceLog();

        this.dbTraceLog.portalTypeID = 1; //Customer Portal
        this.dbTraceLog.ldc = this.ldc;
        this.dbTraceLog.kmiUrlCode = this.param1;
        this.dbTraceLog.issuingApOrderID = this.orderNumber;
        this.dbTraceLog.orderType = this.orderType;
        this.dbTraceLog.logReferenceID = this.logReferenceID;
        this.dbTraceLog.logType = logType;
        this.dbTraceLog.logMessage = logMessage;        
        this.dbTraceLog.emailToList = this.emailToList;

        super.InsertDBTraceLogThruBase(this.dbTraceLog);
    }
}

